export enum CockpitCardType {
  MY_MESSAGES,
  PROJECT_ORGANSIATION,
  APPOINTMENT_MANAGEMENT,
  RELEVANT_PROJECTS,
  ALL_PROJECTS_BY_PHASES,
  MY_APPOINTMENTS,
  MY_PROJECTS,
}

export function getCockpitCardName(
  vue: Vue,
  cockpitCardType: CockpitCardType
): string {
  switch (cockpitCardType) {
    case CockpitCardType.MY_MESSAGES:
      return vue.$t("cockpit.myMessages").toString();
    case CockpitCardType.PROJECT_ORGANSIATION:
      return vue.$t("cockpit.projectOrganisation").toString();
    case CockpitCardType.APPOINTMENT_MANAGEMENT:
      return vue.$t("cockpit.appointmentManagement").toString();
    case CockpitCardType.RELEVANT_PROJECTS:
      return vue.$t("cockpit.relevantProjects").toString();
    case CockpitCardType.ALL_PROJECTS_BY_PHASES:
      return vue.$t("cockpit.allProjects").toString();
    case CockpitCardType.MY_APPOINTMENTS:
      return vue.$t("cockpit.myAppointments").toString();
    case CockpitCardType.MY_PROJECTS:
      return vue.$t("cockpit.myProjects").toString();
  }
}
